import { Link } from 'react-router-dom';
import { Project } from '../../types/project.types';
import { Button } from '../common/Button';

interface ProjectCardProps {
  project: Project;
  onDelete: (projectId: string) => void;
}

export function ProjectCard({ project, onDelete }: ProjectCardProps) {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="text-xl font-semibold text-gray-900 mb-1">{project.name}</h3>
          {project.description && (
            <p className="text-gray-600 text-sm line-clamp-2">{project.description}</p>
          )}
        </div>
      </div>

      <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
        <span>Updated {formatDate(project.updatedAt)}</span>
      </div>

      <div className="flex gap-2">
        <Link to={`/project/${project.id}`} className="flex-1">
          <Button className="w-full">Open Project</Button>
        </Link>
        <Button
          variant="danger"
          onClick={() => {
            if (confirm('Are you sure you want to delete this project?')) {
              onDelete(project.id);
            }
          }}
        >
          Delete
        </Button>
      </div>
    </div>
  );
}
